import React from 'react';
import Navigation from './Navigation';

const TemplateFrame = ({ 
  children,
  assetsData = []
}) => {
  return (
    <div className="template-frame">
      {/* Navigation component (app-icon + slide-out menu) */}
      <Navigation assetsData={assetsData} />

      {/* Page body - where different pages render */}
      <div className="page-body">
        {children}
      </div>
    </div>
  );
};

export default TemplateFrame;
